import { cookie } from "@otto-ec/global-resources/cookie";
import { getCurrentBreakpoint } from "@otto-ec/global-resources/viewport";

import { exactagScope } from "../core/utils";
import { exactagData } from "../core/data";
import type { ExactagData } from "../core/core.types";

const log = exactagScope.scope("collect.generic");

/**
 *
 *
 *
 *
 *
 */
export async function addGenericData(data = exactagData): Promise<ExactagData> {
  Object.assign(data, {
    /*                                                                 */
    uu: cookie.get("BrowserId") || "",

    /*                                       */
    sp: location.pathname.split(/\?|#/)[0].substring(1),

    /*                                                                 */
    pt: "Default",

    /*                                       */
    bp: await getCurrentBreakpoint(),

    /*                                                              */
    sf: window.o_util.cookie.exists("app") ? "app" : "wwwottode",
  });

  log.debug("Added generic data", data);
  return data;
}
